import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { QuestionItem, QuestionTemplate } from '../../../types';
import './QuestionTemplateSelectionModal.css';

interface QuestionTemplateSelectionModalProps {
  show: boolean;
  onHide: () => void;
  questionTemplates: QuestionTemplate[];
  selectedTemplateId: number;
  onSelect: (templateId: number) => void;
}

const QuestionTemplateSelectionModal: React.FC<QuestionTemplateSelectionModalProps> = ({
  show,
  onHide,
  questionTemplates,
  selectedTemplateId,
  onSelect,
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState<QuestionTemplate | null>(null);
  const [templateQuestions, setTemplateQuestions] = useState<Array<QuestionItem>>([]);

  useEffect(() => {
    if (selectedTemplateId && questionTemplates.length > 0) {
      const template = questionTemplates.find(t => t.id === selectedTemplateId);
      if (template) {
        setSelectedTemplate(template);
        const sortedQuestions = template.questions.sort((a: QuestionItem, b: QuestionItem) => a.order - b.order);
        setTemplateQuestions(sortedQuestions);
      }
    }
  }, [selectedTemplateId, questionTemplates]);

  const handleTemplateSelect = (template: QuestionTemplate): void => {
    setSelectedTemplate(template);
    const sortedQuestions = template.questions.sort((a: QuestionItem, b: QuestionItem) => a.order - b.order);
    setTemplateQuestions(sortedQuestions);
  };

  const handleConfirm = (): void => {
    if (selectedTemplate) {
      onSelect(selectedTemplate.id);
      onHide();
    }
  };

  return (
    <Modal
      show={show} 
      onHide={onHide} 
      size="lg" 
      centered
      className="question-template-selection-modal"
      backdrop="static"  // Prevent close when clicking outside
      keyboard={false}   // Optional: Prevent closing with ESC key
    >
      <Modal.Header closeButton>
        <Modal.Title>質問選択</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={5} className="template-list-column">
            <div className="template-list">
              {questionTemplates.map((template) => (
                <div
                  key={template.id}
                  className={`template-item ${selectedTemplate?.id === template.id ? 'selected' : ''}`}
                  onClick={() => handleTemplateSelect(template)}
                >
                  <div className="template-name">
                    {template.name}（{template.questions?.length}問）{selectedTemplate?.id === template.id ? ' ⯈' : ''}
                  </div>
                </div>
              ))}
            </div>
          </Col>
          <Col md={7} className="question-preview-column">
            <div className="question-preview">
              {selectedTemplate ? (
                <div>
                  {templateQuestions.map((question, index) => (
                    <div key={`question-${index + 1}`} className="question-item">
                      <div className="question-text">Q{index + 1}. {question.text.replace(/{candidate_name}/g, '候補者')}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center text-muted">質問テンプレートを選択してください</div>
              )}
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="success" 
          onClick={handleConfirm}
          disabled={!selectedTemplate}
        >
          選択
        </Button>
        <Button variant="secondary" onClick={onHide}>
          キャンセル
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QuestionTemplateSelectionModal;
